import React, { useState, useEffect } from "react";
import { useSnackbar } from 'notistack';
import { withRouter } from "react-router";
import moment from "moment";
import { Table, TableBody, TableCell, TableHead, TableRow, Paper, Grid, Button, TextField, Dialog, DialogContent, DialogTitle, DialogActions, Tooltip, CircularProgress, Checkbox, FormControl, FormLabel, RadioGroup, FormControlLabel, Radio } from '@material-ui/core';
import { Pagination, STableLoader, FilterComponent, PageLoader, EmptyCollection, DeletePopUp } from '../../shared_elements';
import { TechSpecsNav } from '../../elements'
import { AssetInfo } from '../components'
import EditIcon from '@material-ui/icons/Edit';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import { globalGetService, globalPutService, globalPostService, globalDeleteService, globalExportService } from '../../../globalServices';
import { checkApiStatus, checkPermission,  } from '../../utils_v2';
import useAssetInfo from '../hooks/useAssetInfo';
import { downloadFileType } from '../../../utils';
import { assetTypeValues, backendDateFormat, displayDateFormat, fieldDateFormat } from '../../../constants'
import { trackActivity } from "../../../utils/mixpanel";
import { KeyboardDatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import MomentUtils from "@date-io/moment";
import { testLessor, titanAviInstance } from "../../../shared/components";
import ReadMoreInline from "../../../shared/components/ReadMoreInline";
import { Autocomplete } from "@material-ui/lab";
import AddIcon from '@material-ui/icons/Add';
import { usePageTitleOffset } from '../../elements/CollapsibleSideNav';
const OperationalHistoryHd = () => {
    return (
        <TableHead>
        {titanAviInstance || testLessor?
            <TableRow>
                <TableCell>Action(s)</TableCell>
                <TableCell>Registration</TableCell>
                <TableCell>Operator</TableCell>
                <TableCell>Country</TableCell>
                <TableCell>From Date</TableCell>
                <TableCell>To Date</TableCell>
                <TableCell>Remarks</TableCell>
            </TableRow>:
            <TableRow>
                <TableCell>Action(s)</TableCell>
                <TableCell>From Date</TableCell>
                <TableCell>To Date</TableCell>
                <TableCell>Operator Name</TableCell>
            </TableRow>
            }
        </TableHead>
    )
}
const OperationalHistoryList = ({ item, onEdit, onDelete, index }) => {
     const [showMore, setShowMore] = useState({});
        const toggleDescription = (field) => {
            setShowMore({
                ...showMore,
                [field]: !showMore[field]
            })
        }
    return (
        titanAviInstance || testLessor ?
        <TableRow>
            <TableCell align='left'>
                <ul className="list-inline">
                    <li className="list-inline-item hover-inline" onClick={onEdit}>
                        <Tooltip title='Edit' arrow><EditIcon color="primary" fontSize="small" /></Tooltip>
                    </li>
                    <li className="list-inline-item hover-inline " onClick={onDelete}>
                        <Tooltip title='Delete' arrow><DeleteOutlineIcon color="secondary" fontSize="small" /></Tooltip>
                    </li>
                </ul>
            </TableCell>
            <TableCell> {item?.registration || '--'}</TableCell>
            <TableCell> <ReadMoreInline text={item?.operator?.name} maxLength='30' /> </TableCell>
            <TableCell>  <ReadMoreInline text={item?.country} maxLength='30' /></TableCell>
        <TableCell>
            {item?.from_date ? moment(item.from_date).format(displayDateFormat) : '--'}
        </TableCell>
        <TableCell>
            {item?.to_date ? moment(item.to_date).format(displayDateFormat) : '--'}
        </TableCell>
        <TableCell>
            <ReadMoreInline text={item?.remarks} maxLength='30' />
        </TableCell>
    </TableRow>:
        <TableRow>
            <TableCell align='left'>
                <ul className="list-inline">
                    {checkPermission('technical_specs', 'operating_history', 'U') ?
                    <li className="list-inline-item hover-inline" onClick={onEdit}>
                        <Tooltip title='Edit' arrow><EditIcon color="primary" fontSize="small" /></Tooltip>
                    </li>
                    :null}
                     {checkPermission('technical_specs', 'operating_history', 'D') ?
                    <li className="list-inline-item hover-inline " onClick={onDelete}>
                        <Tooltip title='Delete' arrow><DeleteOutlineIcon color="secondary" fontSize="small" /></Tooltip>
                    </li>
                  : null}
                </ul>
            </TableCell>
            <TableCell>
                {item?.from_date ? moment(item.from_date).format(displayDateFormat) : '--'}
            </TableCell>
            <TableCell>
                {item?.to_date ? moment(item.to_date).format(displayDateFormat) : '--'}
            </TableCell>
            <TableCell>
            {item?.operator_name && item?.operator_name?.length > 30 ? (
                        <div >
                            {showMore[item?.field] && showMore[item?.field] ? (
                                <span> {item?.operator_name}
                                    <a href='#' style={{ color: '#0E7FE1', fontSize: '12px' }} onClick={(e) => { e.preventDefault(); toggleDescription(item.field); }}  >  less </a>
                                </span>
                            ) : (
                                <span> {item.operator_name.substring(0, 25)}
                                    <a href='#' style={{ color: '#0E7FE1', fontSize: '12px' }} onClick={(e) => { e.preventDefault(); toggleDescription(item.field); }}  > ..more </a>
                                </span>
                            )}
                        </div>
                    ) :
                        <div>{item?.operator_name || '--'}</div>
                    }
            </TableCell>
        </TableRow>
    )
}
const AddEditOperationalHistory = ({ params, addEditOpHistory, toggleModalFn, getResponseBack, assetInfoData, setCurrentPage, lessees }) => {
    const { enqueueSnackbar } = useSnackbar();
    const [isLoading, setLoading] = useState(false);
    const [opHistory, setOpHistory] = useState(addEditOpHistory?.data);
    const [error, setError] = useState({});
    const onAddEditOpHistory = () => {
        let validationInputs = {}
        validationInputs = {
            ...validationInputs,
            from_date:!opHistory?.from_date? "From Date is required": !moment(opHistory?.from_date).isValid()? "From Date is not valid": !assetInfoData?.date_of_manufacture || moment(opHistory.from_date).isBefore(assetInfoData.date_of_manufacture)? `From Date can't be before Date of Manufacture`: "",
            to_date:!opHistory?.to_date? titanAviInstance || testLessor? '': "To Date is required" : !moment(opHistory?.to_date).isValid() ? "To Date is not valid" : moment(opHistory.to_date).isBefore(opHistory.from_date) ? "To Date can't be before From Date" : !assetInfoData?.date_of_manufacture || moment(opHistory.to_date).isBefore(assetInfoData.date_of_manufacture) ? "To Date can't be before Date of Manufacture" : "",
            operator_name: titanAviInstance || testLessor? '': !opHistory?.operator_name ? "Please enter Operator Name" : "",
            operator: titanAviInstance || testLessor? opHistory?.operator ?'': 'Please select operator' :'' 
        }
        if (Object.keys(validationInputs).every((k) => { return validationInputs[k] === '' })) {
            setLoading(true)
            if (opHistory.id) {
                globalPutService(`console/${params.type}/${params.aircraft_slug}/operational-history/${opHistory.id}/`, opHistory)
                    .then(response => {
                        if (checkApiStatus(response)) {
                            enqueueSnackbar(response.data.message, { variant: 'success', anchorOrigin: { horizontal: 'right', vertical: 'top' }, });
                            toggleModalFn();
                            getResponseBack();
                            setCurrentPage(1);
                        }
                        setLoading(false)
                    })
            } else {
                globalPostService(`console/${params.type}/${params.aircraft_slug}/operational-history/`, opHistory)
                    .then(response => {
                        if (checkApiStatus(response)) {
                            enqueueSnackbar(response.data.message, { variant: 'success', anchorOrigin: { horizontal: 'right', vertical: 'top' }, });
                            trackActivity('Console Management', { page_title: 'Operating History', asset_type: assetTypeValues[assetInfoData?.asset_type.type].label, asset_name: assetInfoData?.serial_number, event_type: 'Item Added', event_desc: 'Added Operating History data' });
                            toggleModalFn();
                            getResponseBack();
                            setCurrentPage(1);
                        }
                        setLoading(false)
                    })
            }
        } else {
            setError(validationInputs)
        }
    }
    const onFieldChange = (key, value) => { setOpHistory({ ...opHistory, [key]: value }) }
    return (
        <Dialog
            open={addEditOpHistory.modal}
            // onClose={toggleModalFn}
            className='console-management-modal'
            maxWidth="md"
        >
            <DialogTitle id="scroll-dialog-title">
                {addEditOpHistory.data.id ? 'Edit ' : 'Add '} Operating History
            </DialogTitle>
            <DialogContent dividers={true}>
            {titanAviInstance || testLessor?
             <div style={{ width: '500px' }}>
                 <Grid container spacing={1}>
                 <Grid item md={6}>
                            <TextField
                                name='registration'
                                label='Registration'
                                value={opHistory?.registration || ''}
                                fullWidth
                                margin="normal"
                                onChange={(e) => onFieldChange('registration', e.target.value)}
                                InputLabelProps={{ shrink: true }}
                                variant='outlined'
                                inputProps={{ maxLength: 50 }}
                            />
                        </Grid>
                        <Grid item md={6}>
                            <Autocomplete
                            options={lessees || []}
                            value={opHistory?.operator || null}
                            getOptionLabel={option=> option.name}
                            id="operator"
                            onChange={(e, value)=>onFieldChange('operator', value)}
                           renderInput={params => <TextField required error={error.operator} helperText={ error.operator ?'Please select Operator': ''} onFocus={() => setError({ ...error, 'operator': '' })} {...params} label={'Operator'} margin="normal" fullWidth InputLabelProps={{ shrink: true }} variant='outlined' />}
                            />
                        </Grid>
                        <Grid item md={6}>
                            <TextField
                                name='country'
                                label='Country'
                                value={opHistory?.country || ''}
                                fullWidth
                                margin="normal"
                                onChange={(e) => onFieldChange('country', e.target.value)}
                                InputLabelProps={{ shrink: true }}
                                variant='outlined'
                                inputProps={{ maxLength: 100 }}
                            />
                        </Grid>
                        <Grid item md={6}>
                            <MuiPickersUtilsProvider utils={MomentUtils}>
                                <KeyboardDatePicker
                                    required
                                    margin="normal"
                                    id="from_date"
                                    fullWidth
                                    maxDate={moment()}
                                    format={fieldDateFormat}
                                    label='From Date'
                                    InputLabelProps={{ shrink: true }}
                                    value={opHistory?.from_date || null}
                                    onChange={(data, value) => onFieldChange('from_date', data ? moment(data).format(backendDateFormat) : null)}
                                    inputVariant="outlined"
                                    error={error?.from_date ? true : false}
                                    helperText={error?.from_date || ''}
                                    onFocus={() => setError({ ...error, from_date: null })}
                                />
                            </MuiPickersUtilsProvider>
                        </Grid>
                        <Grid item md={6}>
                            <MuiPickersUtilsProvider utils={MomentUtils}>
                                <KeyboardDatePicker
                                    margin="normal"
                                    id="to_date"
                                    fullWidth
                                    format={fieldDateFormat}
                                    label='To Date'
                                    InputLabelProps={{ shrink: true }}
                                    value={opHistory?.to_date || null}
                                    onChange={(data, value) => onFieldChange('to_date', data ? moment(data).format(backendDateFormat) : null)}
                                    inputVariant="outlined"
                                    error={error?.to_date ? true : false}
                                    helperText={error?.to_date || ''}
                                    onFocus={() => setError({ ...error, to_date: null })}
                                />
                            </MuiPickersUtilsProvider>
                        </Grid>
                        <Grid item md={12}>
                            <TextField
                                name='remarks'
                                label='Remarks'
                                value={opHistory?.remarks || ''}
                                fullWidth
                                multiline
                                rows={3}
                                margin="normal"
                                onChange={(e) => onFieldChange('remarks', e.target.value)}
                                InputLabelProps={{ shrink: true }}
                                variant='outlined'
                                inputProps={{ maxLength: 200 }}
                            />
                        </Grid>
                    </Grid>
             </div>:
                <div style={{ width: '500px' }}>
                    <Grid container spacing={1}>
                        <Grid item md={6}>
                            <MuiPickersUtilsProvider utils={MomentUtils}>
                                <KeyboardDatePicker
                                    required
                                    margin="normal"
                                    id="from_date"
                                    fullWidth
                                    format={fieldDateFormat}
                                    label='From Date'
                                    InputLabelProps={{ shrink: true }}
                                    value={opHistory?.from_date || null}
                                    onChange={(data, value) => onFieldChange('from_date', data ? moment(data).format(backendDateFormat) : null)}
                                    inputVariant="outlined"
                                    error={error?.from_date ? true : false}
                                    helperText={error?.from_date || ''}
                                    onFocus={() => setError({ ...error, from_date: null })}
                                />
                            </MuiPickersUtilsProvider>
                        </Grid>
                        <Grid item md={6}>
                            <MuiPickersUtilsProvider utils={MomentUtils}>
                                <KeyboardDatePicker
                                    required
                                    margin="normal"
                                    id="to_date"
                                    fullWidth
                                    format={fieldDateFormat}
                                    label='To Date'
                                    InputLabelProps={{ shrink: true }}
                                    value={opHistory?.to_date || null}
                                    onChange={(data, value) => onFieldChange('to_date', data ? moment(data).format(backendDateFormat) : null)}
                                    inputVariant="outlined"
                                    error={error?.to_date ? true : false}
                                    helperText={error?.to_date || ''}
                                    onFocus={() => setError({ ...error, to_date: null })}
                                />
                            </MuiPickersUtilsProvider>
                        </Grid>
                        <Grid item md={6}>
                            <TextField
                                required
                                name='operator_name'
                                label='Operator Name'
                                value={opHistory?.operator_name || ''}
                                fullWidth
                                margin="normal"
                                onChange={(e) => onFieldChange('operator_name', e.target.value)}
                                InputLabelProps={{ shrink: true }}
                                variant='outlined'
                                inputProps={{ maxLength: 255 }}
                                error={error.operator_name}
                                helperText={error?.operator_name || ''}
                                onFocus={() => setError({ ...error, 'operator_name': '' })}
                            />
                        </Grid>
                    </Grid>
                </div>}
            </DialogContent>
            <DialogActions>
                <Button disabled={isLoading} onClick={toggleModalFn} color='primary' size='small' variant='outlined'>Cancel</Button>
                <Button disabled={isLoading} onClick={onAddEditOpHistory} color='primary' size='small' variant='contained'>
                    {isLoading ? <CircularProgress size={24} /> : 'Save'}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

const OperationalHistory = ({ params }) => {
    const navTitleOffset = usePageTitleOffset('techSpecsNavCollapsed');
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [isLoading, setLoading] = useState(false);
    const [skeletonLoader, setSkeletonLoader] = useState(false);
    const [filter, setFilter] = useState({});
    const [opHistory, setOpHistory] = useState([]);
    const [addEditOpHistory, setAddEditOpHistory] = useState({ modal: false, data: null });
    const [deleteOpHistory, setDeleteOpHistory] = useState({ modal: false, data: null });
    const { assetInfoData, assetSkeletonLoader, refreshAssetInfo } = useAssetInfo(params.type, params.aircraft_slug);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [lessees, setLessees] = useState([]);

    useEffect(() => {
        getOpHistory({per_page:50}, 'skeletonLoader');
        getLessees()
    }, []);
    const getOpHistory = (query = {}, loaderType) => {
        loaderType === 'skeletonLoader' ? setSkeletonLoader(true) : setLoading(true)
        globalGetService(`console/${params.type}/${params.aircraft_slug}/operational-history/`, query)
            .then(response => {
                if (checkApiStatus(response)) {
                    setOpHistory(response.data.data)
                }
                loaderType === 'skeletonLoader' ? setSkeletonLoader(false) : setLoading(false)
            })
    }
    const onDeleteOpHistory = () => {
        setLoading(true);
        globalDeleteService(`console/${params.type}/${params.aircraft_slug}/operational-history/${deleteOpHistory.data.id}/`)
            .then(response => {
                if (checkApiStatus(response)) {
                    enqueueSnackbar(response.data.message, { variant: 'success', anchorOrigin: { horizontal: 'right', vertical: 'top' }, });
                    setDeleteOpHistory({ modal: false, data: null });
                    getOpHistory({per_page:opHistory?.pagination?.per_page}, 'pageLoader');
                    setCurrentPage(1);
                }
                setLoading(false);
            })
    }
     const getLessees = () => {
            globalGetService(`console/lessees/`)
                .then(response => {
                    if (checkApiStatus(response)) {
                        setLessees(response.data.data.lessees)
                    }
                })
        }
    return (
        <section className="asset-tech-specs">
            <AssetInfo assetInfoData={assetInfoData} skeletonLoader={assetSkeletonLoader} getResponseBack={refreshAssetInfo} />
            <Paper elevation={0} className="tech-specs-card console-paper" style={{ height: `${window.innerHeight - 162}px` }}>
                <TechSpecsNav />
                <div className="tech-specs-content" >
                    {skeletonLoader ? <STableLoader count={6} /> :
                        <div style={{ padding: '0px 10px' }}>

                            <Paper elevation={0} className="console-paper" style={{ padding: '4px 8px' }}>
                                <Grid container spacing={1} alignItems="center">
                                    <Grid item md={9}></Grid>
                                    <Grid item md={3}>
                                        <ul className="list-inline flex-centered" style={{ float: 'right' }}>
                                            {checkPermission('technical_specs', 'operating_history', 'C') ?
                                            <li className="list-inline-item">
                                                <Button onClick={() => setAddEditOpHistory({ modal: true, mode: 'add', data: {} })} color='primary' size='small' variant="contained"> <AddIcon style={{ fontSize: '1.15rem' }} />Add</Button>
                                            </li>
                                          :null}

                                        </ul>
                                    </Grid>
                                </Grid>
                            </Paper>
                            <Paper square>
                                <div style={{height:`${(window.innerHeight -  (opHistory?.list?.length ? 275 : 225)) - navTitleOffset}px`,overflow:'auto',marginTop: "3px"}}>
                                <Table className='mui-table-format' stickyHeader>
                                    <OperationalHistoryHd />
                                    <TableBody>
                                        {
                                            opHistory?.list?.map((item, index) =>{
                                                return( <OperationalHistoryList
                                                    key={index}
                                                    item={item}
                                                    index={(currentPage - 1) * itemsPerPage + index + 1} 
                                                    onEdit={() => setAddEditOpHistory({ modal: true, mode: 'edit', data: item })}
                                                    onDelete={() => setDeleteOpHistory({ modal: true, data: item })}
                                                />)
                                            }
                                               )
                                        }
                                    </TableBody>
                                </Table>
                                {!opHistory?.list?.length ? <div style={{ textAlign: 'center' }}><EmptyCollection title='No records found' /></div> : null}
                                </div>
                            </Paper>
                            <Paper square>
                                <Pagination
                                    pagination={opHistory.pagination}
                                    onChangePage={(event, newPage) => { setCurrentPage(newPage + 1); getOpHistory({ ...filter, page: newPage + 1, per_page: itemsPerPage }, 'pageLoader') }}
                                    onChangeRowsPerPage={(event) => { setItemsPerPage(event.target.value); setCurrentPage(1); getOpHistory({ ...filter, page: 1, per_page: event.target.value }, 'pageLoader') }}
                                />
                            </Paper>
                        </div>
                    }
                </div>
                {addEditOpHistory.modal ?
                    <AddEditOperationalHistory
                        params={params}
                        lessees={lessees}
                        setCurrentPage={setCurrentPage}
                        assetInfoData={assetInfoData}
                        addEditOpHistory={addEditOpHistory}
                        toggleModalFn={() => setAddEditOpHistory({ modal: false, data: null })}
                        getResponseBack={() => getOpHistory({per_page:opHistory?.pagination?.per_page}, 'pageLoader')}
                    /> : null
                }
                {deleteOpHistory.modal ?
                    <DeletePopUp
                        modal={deleteOpHistory.modal}
                        title='Delete Operating History'
                        content={`Are you sure, you want to Delete?`}
                        toggleModalFn={() => setDeleteOpHistory({ modal: false, data: null })}
                        deleteRecordFn={onDeleteOpHistory}
                    /> : null
                }
                {isLoading ? <PageLoader /> : null}
            </Paper>
        </section>

    )
}
export default withRouter(OperationalHistory);
